const CLIENT_SECRET = "e330169b35334f8fbb6604f0e212efad";
const CLIENT_ID = "24efa9b185c84f3abe1630d3b53d01a2";
const REDIRECT_URI = "https://musique.dionysosparty.fr";
const AUTH_ENDPOINT = "https://accounts.spotify.com/authorize"
const RESPONSE_TYPE = "code"
const AUTH_URL = `${AUTH_ENDPOINT}?client_id=${CLIENT_ID}&response_type=${RESPONSE_TYPE}&redirect_uri=${REDIRECT_URI}&scope=playlist-modify-public%20user-read-private%20user-read-email%20user-library-read%20user-library-modify%20user-read-playback-state%20user-modify-playback-state`

export { CLIENT_ID, CLIENT_SECRET, REDIRECT_URI, AUTH_ENDPOINT, RESPONSE_TYPE, AUTH_URL};